import { FeatureFlagList } from './featureFlagList';
import { FeatureFlagManager } from './featureFlagManager';

/**
 * Extend global interface to include overrideFeatureFlag and overrideFeatureFlags
 */
declare global {
  interface Window {
    /**
     * Provide access to the feature flag manager and override methods in the
     * global window object, for testing purposes.
     */
    __dev__: {
      /**
       * Override a single feature flag.
       *
       * Example:
       * ```
       * overrideFeatureFlag(FeatureFlagList.AllowCobadgedCards, true);
       * ```
       */
      overrideFeatureFlag: (key: string, value: boolean) => void;
      /**
       * List of feature flags used directly in payment-sdk.
       */
      featureFlagsUsed: typeof FeatureFlagList;
      featureFlagManager: FeatureFlagManager<any>;
    };
  }
}

/**
 * Basic implementation of the FeatureFlagManager, for payments SDK.
 */
export const featureFlagManagerPayments = new FeatureFlagManager(
  FeatureFlagList,
);

/**
 * Expose the feature flag manager to the window object for testing.
 *
 * This is used in the payments SDK to allow for testing of feature flags
 * in a browser environment.
 */
export const overrideFeatureFlag = (key: FeatureFlagList, value: boolean) => {
  featureFlagManagerPayments.override(key, value);
};

/* eslint-disable no-underscore-dangle */
window.__dev__ = window?.__dev__ ?? ({} as unknown as any);
window.__dev__.overrideFeatureFlag = overrideFeatureFlag as any;
window.__dev__.featureFlagManager = featureFlagManagerPayments;
window.__dev__.featureFlagsUsed = FeatureFlagList;
/* eslint-enable no-underscore-dangle */
